import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { Location, User } from '../_models/user';

@Component({
  standalone: false,
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  currentUser: string = '';
  locations: Location[] = [];
  currentLocation: Location;

  constructor(
    private router: Router,
    private authService: AuthService) { }

  ngOnInit() {
    this.authService.currentUser$.subscribe((data: User) => {
      if (this.authService.isAuthenticated()) {
        if (data) {
          this.currentUser = data.name? data.name.toUpperCase() : '';
          //this.locations = this.authService.locationsTemp;
          //this.currentLocation = this.locations[data.selectedLocationIndex];
          this.locations = data.locationRoles? data.locationRoles : this.locations;
          if(this.locations.length > 0) this.currentLocation = this.locations[data.selectedLocationIndex? data.selectedLocationIndex:0];
        }
        
      }
    }); 
  }

  changeProfile(location: Location) {
    if (location.Selected) return;
    this.authService.getProfile(location.LocationId, location.RoleId).subscribe(data => {
      if (data) {
        this.authService.changeCurrentLocation(location.Id);
        this.router.navigateByUrl('/home');
      }
    });
  }

  showMenuLocations() {
    return this.locations.length > 1 && this.currentLocation;
  }

  userClick(e) {
    e.preventDefault();
  }

  logout(e) {
    e.preventDefault();
    this.authService.logoutProv();
  }
}
